
    <nb-menu class="context-menu" [items]="context.items" [tag]="context.tag"></nb-menu>
  